(() => {
  async function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const base = window.Shopify?.routes?.root || '/';
    const grid = root.querySelector('[data-gx-upsell-products]');
    const status = root.querySelector('[data-gx-upsell-status]');
    const ready = root.dataset.ready === 'true';
    const money = amount => new Intl.NumberFormat(document.documentElement.lang || 'en',{style:'currency',currency:root.dataset.currency}).format(amount/100);
    const json = async url => { const r=await fetch(url,{headers:{Accept:'application/json'}}); if(!r.ok) throw new Error(window.GX.s('unableLoadOffer','Unable to load offer')); return r.json(); };
    try {
      const cart = await json(`${base}cart.js`);
      const ordinary = cart.items.filter(i => i.properties?._gx_cart_upsell !== 'v1');
      const extras = cart.items.filter(i => i.properties?._gx_cart_upsell === 'v1').reduce((n,i)=>n+i.quantity,0);
      if (!ordinary.length || extras >= 2) return;
      const existing = new Set(cart.items.map(i=>i.product_id));
      let products = [];
      try { products = (await json(`${base}recommendations/products.json?product_id=${ordinary[0].product_id}&limit=10&intent=related`)).products || []; } catch (_) { /* use catalogue fallback */ }
      products = products.filter(p=>!existing.has(p.id)&&p.available);
      if(products.length < 2-extras) {
        const fallback = await json(`${base}products.json?limit=250`);
        for(const p of fallback.products || []) {
          if(existing.has(p.id)||products.some(x=>x.id===p.id)) continue;
          products.push({ ...p, variants:p.variants.map(v=>({...v,price:Math.round(Number(v.price)*100)})),featured_image:p.images?.[0]?.src });
        }
      }
      products = products.filter(p=>p.variants.some(v=>v.available)).slice(0,2-extras);
      if(!products.length) return;
      root.hidden = false;
      products.forEach(product => {
        const card = document.createElement('article'); card.className='gx-cart-upsell__card';
        const link = document.createElement('a'); link.href=`${base}products/${encodeURIComponent(product.handle)}`;
        const src=product.featured_image || product.images?.[0]?.src || product.images?.[0];
        if(src) { const img=document.createElement('img'); img.src=src;img.alt=product.title;img.loading='lazy';link.append(img); }
        const title=document.createElement('h3');title.textContent=product.title;link.append(title);card.append(link);
        const label=document.createElement('label');label.textContent=window.GX.s('chooseColorSize','Choose color / size');
        const select=document.createElement('select');
        product.variants.forEach(v=>{const option=document.createElement('option');option.value=v.id;option.textContent=v.title+(v.available?'':window.GX.s('optionSoldOut',' — Sold out'));option.disabled=!v.available;select.append(option);});
        select.value=product.variants.find(v=>v.available).id;
        label.append(select);if(product.variants.length>1||product.variants[0].title!=='Default Title') card.append(label);
        const prices=document.createElement('p'); const price=document.createElement('strong');prices.append(price);card.append(prices);
        const update=()=>{const v=product.variants.find(v=>String(v.id)===select.value);price.textContent=money(v.price);};select.addEventListener('change',update);update();
        const button=document.createElement('button');button.type='button';button.textContent=window.GX.s('add','ADD TO BAG');button.disabled=!ready;card.append(button);grid.append(card);
        button.addEventListener('click',async()=>{
          grid.querySelectorAll('button').forEach(b=>b.disabled=true);status.textContent='';
          try {
            // Save pending cart quantities before adding a separate marked offer line.
            const cartForm=root.closest('form');
            if(cartForm) {
              const updates=new FormData(cartForm);
              const saved=await fetch(`${base}cart/update.js`,{method:'POST',body:updates});
              if(!saved.ok) throw new Error(window.GX.s('updateCartTryAgain','Please update your cart and try again.'));
            }
            const fresh=await json(`${base}cart.js`);
            if(!fresh.items.some(i=>i.properties?._gx_cart_upsell!=='v1') || fresh.items.filter(i=>i.properties?._gx_cart_upsell==='v1').reduce((n,i)=>n+i.quantity,0)>=2 || fresh.items.some(i=>i.product_id===product.id)) { sessionStorage.setItem('gx_scroll_top_next','1');location.reload();return; }
            const response=await fetch(`${base}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(select.value),quantity:1,properties:{_gx_cart_upsell:'v1'}}]})});
            const result=await response.json();if(!response.ok) throw new Error(result.description || window.GX.s('unableAddItem','Unable to add this item.'));
            sessionStorage.setItem('gx_scroll_top_next','1');
            location.reload();
          } catch(error) {status.textContent=error.message;grid.querySelectorAll('button').forEach(b=>b.disabled=!ready);}
        });
      });
    } catch(error) { if(!ready) {root.hidden=false;status.textContent=error.message;} }
  }
  const scan=scope=>scope.querySelectorAll('[data-gx-cart-upsell]').forEach(init);
  document.addEventListener('DOMContentLoaded',()=>scan(document));
  document.addEventListener('shopify:section:load',event=>scan(event.target));
})();
